/* eslint-disable quotes */
export default {
  bannerCathedraData: {
    es: [
      {
        name: "small-cathedra",
        imageBanner: "",
        imageDesktopXL: "/assets/images/internal-training/banner-internal-training-desktop.svg",
        imageDesktop: "/assets/images/internal-training/banner-internal-training-desktop.svg",
        imageMobile: "/assets/images/cathedra/banner-cathedra-mobile.webp",
        altImage: "Somos Kairós DS",
        text1: "",
        text2: "Kairós DS",
        text3: "Cátedra",
        buttonText: "",
        buttonLink: "",
        buttonTarget: "",
      },
    ],
    en: [
      {
        name: "small-cathedra",
        imageBanner: "",
        imageDesktopXL: "/assets/images/internal-training/banner-internal-training-desktop.svg",
        imageDesktop: "/assets/images/internal-training/banner-internal-training-desktop.svg",
        imageMobile: "/assets/images/cathedra/banner-cathedra-mobile.webp",
        altImage: "Somos Kairós DS",
        text1: "",
        text2: "Kairós DS",
        text3: "Cátedra",
        buttonText: "",
        buttonLink: "",
        buttonTarget: "",
      },
    ],
  },
};
